export const getIsOnboarded = (state) =>
  state?.user?.profile?.isProfileComplete;
export const getChildren = (state) => state?.children?.children.length !== 0;
export const getUser = (state) => state?.user;
export const checkNewUser = (state) => state?.user?.profile?.isNewUser || false;
export const checkUserPremium = (state) =>
  state?.user?.profile?.premium || false;
